import {
  Box,
  Button,
  Checkbox,
  Collapse,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import MoreIcon from "@material-ui/icons/MoreVert";
import { Bagde } from "components/Card";
import useText from "constants/text";
import { JobContext } from "contexts/JobContext";
import NewParcel from "domains/Parcel/components/Parcels/NewParcel";
import UpdateParcel from "domains/Parcel/components/Parcels/UpdateParcel";
import { useNewOrderStyles } from "domains/Task/components/Job/styles";
import { Order, Parcel } from "generated/graphql";
import {
  DupliquerIcon,
  NewParcelIcon,
  ParcelDeleteIcon,
  ParcelDescriptionIcon,
  ParcelEditIcon,
  SizeIcon,
  TocollectIcon,
  ValueIcon,
} from "icons";
import React from "react";
import styled from "styled-components/macro";
import ActionsGroup from "ui/ActionGroup";

const ActionButon = styled(IconButton)`
  padding: 0;
`;

const Actions = styled.div`
  &.normal {
    height: 20px;
    width: 20px;
    display: flex;
    transition: 0.5s;
    border-radius: 5px;
  }
  &.reception {
  }
`;

interface OrderProps {
  order?: Order;
  addParcel?(order: Order): void;
  onDuplicate?(order: Order): void;
  onDelete?(order: Order): void;
  onEdit?(order: Order): void;
  menu?: boolean;
  warring?: boolean;
  openNewParcel?: boolean;
  setOpenNewParcel?: any;
  handleUpdate?: (order: Order) => void;
  activeStep?: number;
}
export function OrderCollapse({
  order,
  addParcel,
  menu,
  onDelete,
  onDuplicate,
  onEdit,
  openNewParcel,
  setOpenNewParcel,
  handleUpdate,
  warring = false,
  activeStep,
}: OrderProps) {
  const styles = useNewOrderStyles();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [openIconButton, setOpenIconButton] = React.useState(false);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const { parcelIndex, setParcelIndex, job } = React.useContext(JobContext);
  const [data, setData] = React.useState<Order>(order);
  const [openUpdateParcel, setOpenUpdateParcel] = React.useState(false);
  const [parcels, setParcels] = React.useState([]);
  const [currentParcel, setCurrentParcel] = React.useState({});
  const { text } = useText();

  React.useEffect(() => {
    if (data && data.order_parcels?.length > 0) setParcels(data.order_parcels);
  }, [data]);

  React.useEffect(() => {
    if (parcels) {
      const newData = { ...data, order_parcels: parcels };
      handleUpdate && handleUpdate(newData);
    }
  }, [parcels]);

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    handleCloseMenu();
    onEdit(order);
  };
  const handleDuplicate = () => {
    handleCloseMenu();
    onDuplicate(order);
  };
  const handleDelete = () => {
    handleCloseMenu();
    onDelete(order);
  };

  const addColisActions = [
    { key: "1", label: text.all.add_parcels },
    { key: "2", label: text.all.select_from_caalog },
  ];

  const handleActionsClick = (key: string) => {
    switch (key) {
      case "1":
        addParcel(order);
        break;
      case "2":
        break;
      default:
    }
  };

  const handleNewParcel = (parcel: Parcel) => {
    let parcels = [...data?.order_parcels];
    if (!parcels) {
      parcels = [];
    }
    parcel._id = parcelIndex.toString();
    parcels.push(parcel);
    setData((prev) => ({
      ...prev,
      order_parcels: parcels,
    }));
    setParcelIndex(parcelIndex + 1);
  };

  const updateParcel = (parcel: Parcel) => {
    let parcels = data.order_parcels;
    parcels = parcels.map((element) => {
      if (element._id === parcel._id) {
        return parcel;
      }
      return element;
    });
    setData((prev) => ({
      ...prev,
      order_parcels: parcels,
    }));
  };

  const handleEditParcel = (row: Parcel) => {
    setCurrentParcel(row);
    setOpenUpdateParcel(true);
  };

  const deleteParcel = (parcel: Parcel) => {
    let parcels = data.order_parcels;
    parcels = parcels.filter((element) => element._id !== parcel._id);
    setData((prev) => ({
      ...prev,
      order_parcels: parcels,
    }));
    setParcels(parcels);
  };

  const onDuplicateParcel = (parcel: Parcel) => {
    const newParcel: any = {
      ...parcel,
      _id: data.order_parcels[0]._id + parcelIndex?.toString() + data.order_receiver?.receiver_phone_number,
      parcel_description: "",
    };
    setData((prev) => ({
      ...prev,
      order_parcels: [newParcel, ...parcels],
    }));
    setParcels([newParcel, ...parcels]);
  };

  return (
    <>
      <TableContainer component={Paper} style={{ overflowX: "unset" }}>
        <Table aria-label="collapsible table">
          <TableBody>
            <div style={{ borderLeft: activeStep === 2 && "4px solid #399ebf", display: "contents" }}>
              <TableRow
                className={styles.root}
                style={{
                  borderLeft:
                    order?.order_receiver?.receiver_phone_number === "" ||
                    order?.order_parcels[0]?.parcel_description === ""
                      ? "4px solid red"
                      : "",
                }}
              >
                <div className={styles.divTableCell}>
                  <div className={styles.divTable}>
                    <div>
                      {activeStep !== 2 && (
                        <TableCell style={{ padding: "0.5rem 0px 0.5rem 0px" }}>
                          <div style={{ padding: "3px" }}>
                            <Checkbox />
                          </div>
                        </TableCell>
                      )}
                      {activeStep !== 2 && (
                        <TableCell>
                          <IconButton
                            aria-label="expand row"
                            size="small"
                            onClick={() => setOpenIconButton(!openIconButton)}
                          >
                            <div
                              style={{
                                backgroundColor: "#399ebf",
                                borderRadius: "6px",
                                color: "#fff",
                                margin: "14px",
                                height: "25px",
                              }}
                            >
                              {openIconButton ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                            </div>
                          </IconButton>
                        </TableCell>
                      )}
                    </div>
                    <div className={styles.divTable}>
                      <TableCell className={styles.tableCellName} component="th" scope="row">
                        <div style={{ position: "relative", top: "17px", left: "6px" }}>
                          <NewParcelIcon width={38} height={40} />
                        </div>
                      </TableCell>
                      <TableCell className={styles.tableCellName} component="th" scope="row">
                        {order?.order_receiver?.receiver_firstname} {order?.order_receiver?.receiver_lastname}
                      </TableCell>
                      <TableCell className={styles.tableCellAddress} align="right">
                        {order?.order_receiver?.receiver_phone_number}
                      </TableCell>
                      <TableCell className={styles.tableCellAddress} align="right">
                        {order?.order_receiver?.receiver_address.address}
                      </TableCell>
                    </div>
                  </div>
                  <div className={styles.rightAction}>
                    <TableCell align="left" style={{ width: "12px" }}>
                      {activeStep !== 2 && (
                        <ActionsGroup
                          padding="0 50px"
                          actions={addColisActions}
                          buttonName={text.all.add_parcels}
                          isParcel
                          onClick={handleActionsClick}
                        />
                      )}
                    </TableCell>
                    <TableCell align="right">
                      {activeStep !== 2 && (
                        <Box className={styles.BoxBadge}>
                          <Bagde
                            value={parcels ? parcels?.length.toString() : "0"}
                            height={17}
                            width={17}
                            variante="contained"
                            fontSize={8}
                          />
                        </Box>
                      )}
                      {activeStep === 2 && (
                        <Box className={styles.recapBadge}>
                          <div className={styles.recapBadgeItem}>{parcels?.length.toString()}</div>
                          <span className={styles.recapBadgeText}>{text.all.parcel}</span>
                        </Box>
                      )}
                    </TableCell>

                    <TableCell className={styles.multipleActions}>
                      <div style={{ position: "relative", top: "-9px", marginRight: "10px" }}>
                        <Actions>
                          {!true && (
                            <Button
                              variant="outlined"
                              className={styles.newParcel}
                              color="primary"
                              onClick={(e) => {
                                e.stopPropagation();
                                addParcel(order);
                              }}
                            >
                              {text.all.add_parcels}
                            </Button>
                          )}
                          {activeStep !== 2 && (
                            <ActionButon aria-label="display more actions" color="default" onClick={handleClick}>
                              <MoreIcon />
                            </ActionButon>
                          )}

                          {true && (
                            <Menu
                              id="long-menu"
                              anchorEl={anchorEl}
                              keepMounted
                              open={open}
                              onClose={handleCloseMenu}
                              PaperProps={{
                                style: {
                                  maxHeight: 48 * 4.5,
                                  width: "11ch",
                                  marginTop: "2.4rem",
                                  marginLeft: "0.5rem",
                                },
                              }}
                            >
                              <MenuItem
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleEdit();
                                }}
                              >
                                {text.all.edit}
                              </MenuItem>
                              <MenuItem
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleDuplicate();
                                }}
                              >
                                {text.all.duplicate}
                              </MenuItem>
                              <MenuItem
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleDelete();
                                }}
                              >
                                {text.all.delete}
                              </MenuItem>
                            </Menu>
                          )}
                        </Actions>
                      </div>
                    </TableCell>
                  </div>
                </div>
              </TableRow>
              <TableRow style={{ border: "none" }}>
                <TableCell
                  style={{
                    display: `${!openIconButton ? "none" : ""}`,
                    borderLeft: "4px solid #399ebf",
                  }}
                  colSpan={6}
                >
                  <Collapse
                    in={openIconButton}
                    timeout="auto"
                    unmountOnExit
                    style={{ marginLeft: "-20px", width: "104%" }}
                  >
                    <Box>
                      <div className={styles.tableParcel} style={{ margin: "0px !important" }}>
                        <Table>
                          <TableBody>
                            {parcels.length === 0 ? (
                              <Box className={styles.texteIndicatif}>Ce receveur na pas encore de colis</Box>
                            ) : (
                              parcels.map((parcel: any) => (
                                <>
                                  <TableRow>
                                    <TableCell
                                      style={{
                                        borderLeft: !parcel?.parcel_description ? "4px solid red" : "",
                                      }}
                                    >
                                      <div className={styles.flex}>
                                        <div style={{ padding: "3px" }}>
                                          <Checkbox />
                                        </div>
                                        <ParcelDescriptionIcon />
                                        <div className={styles.iconRef}>
                                          <Box>Refference: {parcel?.parcel_client_reference}</Box>
                                          <Box>Description: {parcel?.parcel_description}</Box>
                                        </div>
                                      </div>
                                    </TableCell>

                                    <TableCell component="th" scope="row">
                                      <div className={styles.flex}>
                                        <SizeIcon />
                                        <div className={styles.icon}>
                                          <Box className={styles.iconBox}>Size:</Box>
                                          {parcel?.parcel_size}(Max 5kg)
                                        </div>
                                      </div>
                                    </TableCell>

                                    <TableCell component="th" scope="row">
                                      <div className={styles.flex}>
                                        <ValueIcon />
                                        <div className={styles.icon}>
                                          <Box className={styles.iconBox}>Value:</Box>
                                          {parcel?.parcel_value} CFA
                                        </div>
                                      </div>
                                    </TableCell>

                                    <TableCell component="th" scope="row">
                                      <div className={styles.flex}>
                                        <TocollectIcon />
                                        <div className={styles.icon}>
                                          <Box className={styles.iconBox}>To collect:</Box>
                                          {parcel?.parcel_amount_to_collect} CFA
                                        </div>
                                      </div>
                                    </TableCell>

                                    <TableCell
                                      className={styles.tableCellActions}
                                      align="right"
                                      component="th"
                                      scope="row"
                                    >
                                      <Box>
                                        <div onClick={() => deleteParcel(parcel)}>
                                          <ParcelDeleteIcon color="#399ebf" />
                                        </div>
                                      </Box>
                                      <Box>
                                        <div onClick={() => onDuplicateParcel(parcel)}>
                                          <DupliquerIcon color="#399ebf" />
                                        </div>
                                      </Box>
                                      <Box>
                                        <div onClick={() => handleEditParcel(parcel)}>
                                          <ParcelEditIcon color="#399ebf" />
                                        </div>
                                      </Box>
                                    </TableCell>
                                  </TableRow>
                                </>
                              ))
                            )}
                          </TableBody>
                        </Table>
                      </div>
                    </Box>
                  </Collapse>
                </TableCell>
              </TableRow>
            </div>
          </TableBody>
        </Table>
      </TableContainer>

      <NewParcel
        order={order}
        open={openNewParcel}
        handleClose={() => setOpenNewParcel(false)}
        handleNew={handleNewParcel}
        handleUpdate={handleUpdate}
        job={job}
      />

      <UpdateParcel
        parcel={currentParcel}
        open={openUpdateParcel}
        order={order}
        handleClose={() => setOpenUpdateParcel(false)}
        handleUpdate={updateParcel}
        job={job}
      />
    </>
  );
}

export default OrderCollapse;
